import { ExternalLink, LogOut } from 'lucide-react'
import { useState } from 'react'
import { Kiezer, Kop } from '../onderdelen/ui'
import { uitloggen } from '../lib/api'
import { bewaarVoorkeuren, leesVoorkeuren, useStaat } from '../lib/staat'

/* ===========================================================================
 *  Voorkeuren
 *
 *  Per toestel en klein: welk bedrijf er bij Scannen bovenaan staat, of je na
 *  het tekenen meteen doorgaat naar de volgende (zoals het dashboard), de weg
 *  naar het volledige dashboard, en uitloggen.
 *
 *  "Volledig dashboard" opent het dashboard met ?telefoon=uit. Dat zet op
 *  DIT toestel het doorsturen naar TW10 uit (zie AdministratieDashboard in
 *  de dashboard-repo), zodat je daar ook op de telefoon bij alles kunt. Het
 *  dashboard zet het weer aan met ?telefoon=aan, of via de knop TW10 op de
 *  werkplek.
 * =========================================================================== */

const DASHBOARD = 'https://dashboard.truckwash-workspace.com/'

export default function Voorkeuren() {
  const ik = useStaat((s) => s.ik)
  const [v, setV] = useState(leesVoorkeuren)
  const [kies, setKies] = useState(false)

  const zet = (deel: Partial<typeof v>) => { const n = { ...v, ...deel }; setV(n); bewaarVoorkeuren(n) }
  const bedrijfNaam = v.bedrijf ? ik?.bedrijven.find((b) => b.code === v.bedrijf)?.naam ?? v.bedrijf : 'Geen'

  return (
    <div className="scherm">
      <Kop terugNaar="/" terugLabel="Dashboard" titel="Voorkeuren" />

      <ul className="lijst groep">
        <li className="lijst-rij voorkeur-rij">
          <span className="kiezer-tekst"><span>{ik?.ik.naam}</span><span className="klein zacht">Ingelogd via het dashboard</span></span>
        </li>
      </ul>

      <ul className="lijst groep">
        <li>
          <button className="lijst-rij voorkeur-rij" onClick={() => setKies(true)}>
            <span className="kiezer-tekst"><span>Bedrijf bij scannen</span><span className="klein zacht">Staat bovenaan bij Kies bedrijf</span></span>
            <span className="zacht afkap rechts-tekst">{bedrijfNaam}</span>
          </button>
        </li>
        <li className="lijst-rij voorkeur-rij">
          <label className="schakel-rij">
            <span className="kiezer-tekst"><span>Na tekenen door naar de volgende</span><span className="klein zacht">Zoals in het dashboard; uit = terug naar de lijst</span></span>
            <input type="checkbox" className="schakelaar" checked={v.doorNaVolgende !== false}
              onChange={(e) => zet({ doorNaVolgende: e.target.checked })} />
          </label>
        </li>
      </ul>

      <ul className="lijst groep">
        <li>
          <a className="lijst-rij voorkeur-rij" href={`${DASHBOARD}?telefoon=uit`}>
            <span className="kiezer-tekst"><span>Volledig dashboard openen</span><span className="klein zacht">Op dit toestel stuurt het dashboard je dan niet meer hierheen</span></span>
            <ExternalLink size={18} className="zacht" />
          </a>
        </li>
        <li>
          <button className="lijst-rij voorkeur-rij rood" onClick={async () => { await uitloggen(); location.replace('/') }}>
            <span>Uitloggen</span>
            <LogOut size={18} />
          </button>
        </li>
      </ul>

      {kies && (
        <Kiezer titel="Bedrijf bij scannen" terugLabel="Voorkeuren" zoekbaar
          opties={[{ waarde: '', label: 'Geen' }, ...(ik?.bedrijven ?? []).map((b) => ({ waarde: b.code, label: b.naam }))]}
          gekozen={v.bedrijf ?? ''} kies={(w) => zet({ bedrijf: w || undefined })} sluit={() => setKies(false)} />
      )}
    </div>
  )
}
